import { useEffect, useState } from "react";

function DateTimeHeader() {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="header-datetime">
      <div>{dateTime.toLocaleDateString()}</div>
      <div>{dateTime.toLocaleTimeString()}</div>
    </div>
  );
}

export default DateTimeHeader;
